import Helper from './helper'
import Question from '@/model/question';

export class PairContent {
  constructor({ content, subContent, type }) {
    this.content = content
    this.subContent = subContent
    this.type = type
  }
}

export class QuestionPair {
  constructor (aContent, bContent) {
    this.a = aContent
    this.b = bContent
  }
}

export default class Flashcard {
  constructor (pairs, color) {
    this.pairs = Helper.shuffle(pairs)
    this.color = color
  }

  static async createFromQuiz(part) {
    const data = await part.getData()
    let shuffleAnswers = data.shuffleAnswers
    this.questions = Helper.shuffle(data.questions.map((data, idx) => new Question(this, data, idx, shuffleAnswers)))

    const pairs = data.questions.map((data, idx) => {
      const question = new Question(this, data, idx, shuffleAnswers)
      return new QuestionPair(
        new PairContent({
          content: question.title,
          subContent: question.subtitle,
          type: 'Text',
        }),
        new PairContent({
          content: question.getSolutionText(),
          type: 'Text',
        })
      );
    })
    return new Flashcard(pairs, part.lesson.color)
  }

  static async createFromPairs(part) {
    const data = await part.getData()
    const pairs = data.pairs.map(p => {
      return new QuestionPair(
        new PairContent({
          content: p.a.content,
          type: p.a.type,
        }),
        new PairContent({
          content: p.b.content,
          type: p.b.type,
        })
      );
    })
    return new Flashcard(pairs, part.lesson.color)
  }
}
